
let dialogSeed = 0;

export default {
  name: "XcoinsStatusDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "error",
      validator: (value) => ["success", "error", "warning"].includes(value),
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    primaryText: {
      type: String,
      default: "",
    },
    secondaryText: {
      type: String,
      default: "",
    },
    closable: {
      type: Boolean,
      default: true,
    },
    closeOnMask: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    dialogSeed += 1;
    return {
      dialogId: dialogSeed,
    };
  },
  computed: {
    titleId() {
      return `xcoins-status-title-${this.dialogId}`;
    },
    descriptionId() {
      return `xcoins-status-description-${this.dialogId}`;
    },
    statusImage() {
      return this.type === "success"
        ? require("@/assets/image/global/icon_dialog_success.png")
        : require("@/assets/image/global/icon_dialog_error.png");
    },
  },
  watch: {
    visible(value) {
      if (process.client) {
        document.body.style.overflow = value ? "hidden" : "";
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
    if (process.client) {
      document.body.style.overflow = "";
    }
  },
  methods: {
    handleMaskClick() {
      if (this.closeOnMask) {
        this.$emit("close");
      }
    },
    handleKeydown(event) {
      if (this.visible && this.closable && event.key === "Escape") {
        this.$emit("close");
      }
    },
  },
};
